import { render, staticRenderFns } from "./addShopTypeMenu.vue?vue&type=template&id=1893925a"
import script from "./addShopTypeMenu.vue?vue&type=script&lang=js"
export * from "./addShopTypeMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports